export const environment = {
  url: {
    api: `https://apim-dev.houseofhr.com/square-app-houseofcovebo/api/v2.0`,
  },
  production: false,
  ocpApimSubscriptionKey: '2420136688ec41579409608eb628dbde'
};

